<template>
    <!--content-->
    <div class="courses-single-page mt-0 pt-4 pb-4 mb-0 bg-white" style="min-height: 700px; overflow-y: auto;">
        <div class="back-button">
            <button type="button" class="btn-save ml-1" v-on:click="save">Save</button>
            <button type="button" class="btn-clone ml-1" v-on:click="clone">Clone</button>
            <button type="button" class="btn-clone ml-1" v-on:click="$router.push('/admin/courses')">Back</button>
            <button type="button" class="btn-delete ml-1" v-if="course && course.id > 0" v-on:click="deleteConfirmation = true">Delete course</button>
        </div>
        <!--main card-->
        <div class="card m-5 overflow-hidden border-0 mt-0 pt-5 mb-4" style="min-height: 650px; background-color: #f1f1f1; box-shadow: black 2px 2px 10px;">
            <div class="row top-wrapper" style="background-color: #f1f1f1;">
                <div class="col-12">
                    <div class="row mb-2 pl-5 pr-5" v-if="course">
                        <div class="col-12 d-flex flex-wrap">
                            <course-image-header :initialCourse="course" v-on:fileChange="handleFileChange" :edit="editEnabled" />
                            <course-name-header :courseName="course.name" :edit="editEnabled" v-on:handleNameChanged="nameChanged" />
                        </div>
                    </div>
                    <course-actions v-if="course" :initialCourse="course" :edit="editEnabled" :tab="selectedTab" v-on:tabClick="handleTabClicked" />

                </div>
            </div>

            <div class="row content-wrapper pt-0 pb-0" v-if="courseDetails && course" style="min-height: 400px;">
                <div class="col-12">

                    <div class="row tab-wrapper" v-show="selectedTab == 0">
                        <div class="col-12 pl-0 pr-0">
                            <div class="tab-content-wrap">
                                <course-info :initialAuthors="authors" :initialCourse="course" :initialCourseDetails="courseDetails" :tab="selectedTab" :edit="editEnabled" :initialSites="sites" v-on:toggleEdit="handleToggleEdit" />
                            </div>
                        </div>
                    </div>

                    <div class="row tab-wrapper" v-show="selectedTab == 1">
                        <div class="col-12 pl-0 pr-0">
                            <certificate-page :tab="selectedTab" :edit="editEnabled" :initialCourses="courses" :initialCourseDetails="courseDetails" :initialCourse="course" v-on:toggleEdit="handleToggleEdit" v-on:fileChanged="onFileChange" v-on:handleDelete="showDeleteModal" :parentThis="this" />
                        </div>
                    </div>

                    <div class="row tab-wrapper h-100" v-show="selectedTab == 2">
                        <div class="col-12 pl-0 pr-0">

                            <students-page :edit="editEnabled" :tab="selectedTab" :initialAllocations="allocations" v-on:toggleEdit="handleToggleEdit" v-on:eval="evaluate" />
                        </div>
                    </div>

                    <div class="row tab-wrapper h-100" v-show="selectedTab == 6 && course.isFacilitated">
                        <div class="col-12 pl-0 pr-0">
                            <attendees-page :initialAttendees="courseAttendees" :initialCourse="course" :initialCourseDetails="courseDetails" />
                        </div>
                    </div>

                    <div class="row tab-wrapper" v-show="selectedTab == 3">
                        <div class="col-12 pl-0 pr-0">
                            <coupons-page :edit="editEnabled" :tab="selectedTab" :initialCourse="course" v-on:toggleEdit="handleToggleEdit" :initialCouponCount="couponCount" :discountPercentage="couponDiscountPercentage" v-on:handleGenerateCoupon="generateCoupon" v-on:handleShowAddCoupons="toggleShowAddCoupons" />
                        </div>
                    </div>

                    <div class="row tab-wrapper" v-show="selectedTab == 4">
                        <div class="col-4 pl-0 pr-0">
                            <side-menu :edit="editEnabled" :tab="selectedTab" :chapter="selectedChapter" :page="selectedPage" :initialCourseDetails="courseDetails" v-on:changePage="handlePageChange" v-on:handleAddPage="addPage" v-on:handleAddChapter="addChapter" v-on:handleDrop="onDrop" v-on:handleDrag="startDrag" v-on:handleInputLeave="inputLeave" v-on:handleInputEnter="inputEnter" v-on:handleToggle="toggleShow" v-on:handleDeleteItem="showDeleteModal" />
                        </div>
                        <div class="col-8 pl-0 pr-0">
                            <content-display :tab="selectedTab" :chapter="selectedChapter" :page="selectedPage" :edit="editEnabled" :initialCourseDetails="courseDetails" v-on:handleTypeChange="onTypeChange" v-on:handleDrag="startDrag" v-on:handleDrop="onDrop" v-on:handleMoveItem="moveItem" v-on:handleDelete="deleteItem" v-on:handleAddAnswer="addAnswer" v-on:handleUpdateHtml="updateComponentHtml" v-on:fileChange="handleFileChange" v-on:handleAddComponent="addComponent" v-on:toggleEdit="handleToggleEdit" />
                        </div>
                    </div>

                    <div class="row tab-wrapper" v-show="selectedTab == 5">
                        <div class="container-fluid mt-3">
                            <div class="col-12 pl-0 pr-0">
                                <div class="title">
                                    Course Features
                                </div>
                                <div class="row">
                                    <div class="col-6">
                                        <div class="card h-100 p-3">
                                            <div class="d-flex justify-content-between pb-2">
                                                <div class="title">
                                                    New Feature
                                                </div>
                                                <button v-on:click="addFeature">Add feature</button>
                                            </div>
                                            <div v-if="activeCourseFeature">
                                                <div class="row">
                                                    <div class="col-6">
                                                        <div class="d-flex flex-column">
                                                            <label class="mr-3">Icon</label>
                                                            <input type="text" name="featureIcon" placeholder="Feature icon" v-model="activeCourseFeature.featureIcon" />
                                                        </div>
                                                    </div>
                                                    <div class="col-6">
                                                        <div class="d-flex flex-column">
                                                            <label class="mr-3">Name</label>
                                                            <input type="text" name="featureName" placeholder="Feature name" v-model="activeCourseFeature.featureName" />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-12">
                                                        <div class="d-flex flex-column">
                                                            <label class="mr-3">Value</label>
                                                            <input type="text" name="featureValue" placeholder="Feature value" v-model="activeCourseFeature.featureValue" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-else>
                                                Click the button to add a new feature
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-6">
                                        <div class="card h-100 p-3">
                                            <div class="title">
                                                Features
                                            </div>
                                            <div class="features-list">
                                                <ul class="list-group" v-if="courseDetails.courseFeatures && courseDetails.courseFeatures.length > 0">
                                                    <li class="list-group-item d-flex justify-content-between align-items-center" v-for="feature in courseDetails.courseFeatures" v-on:click="selectFeature(feature)">
                                                        <div>
                                                            <i v-if="feature.featureIcon" class="mr-2" v-bind:class="feature.featureIcon"></i>
                                                            <span>
                                                                {{feature.featureName !== "" ? feature.featureName : "Enter name..."}}
                                                            </span>
                                                        </div>
                                                        <span>
                                                            {{feature.featureValue !== "" ? feature.featureValue : "Enter value..."}}
                                                        </span>
                                                        <button class="btn btn-danger" v-on:click="removeFeature(feature)">Delete</button>
                                                    </li>
                                                </ul>
                                                <ul class="list-group" v-else>
                                                    <li class="list-group-item">No features yet!</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>

        <!--delete modal-->
        <div v-if="deleteConfirmation" id="dlete-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true" style="display:block; z-index: 99999; background-color: rgba(22,9,61, 0.5)">
            <div style="margin-top: 320px">
                <!--class= modal-dialog-->
                <div>
                    <div class="card h-100 ml-auto mr-auto w-50 bg-dark-blue text-white pl-2 pt-2 pr-2" style="border-bottom: none;">
                        <div class="container">
                            <div class="title text-white">
                                Delete Course
                            </div>
                            <div>
                                <label class="text-white">Are you sure you want to delete this course? <br />All students will lose access and associated coupons will no longer be usable</label>
                            </div>
                            <div class="d-flex justify-content-end mt-5 mb-3">
                                <button v-on:click="deleteCourse" class="btn btn-danger">Yes - Delete</button>
                                <button v-on:click="deleteConfirmation=false" class="btn-add-alt-2 ml-2">No - Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--add coupons modal-->
        <div v-if="showAddCoupons && editEnabled" id="add-coupons-modal" class="modal in" tabindex="-1" role="dialog" aria-hidden="true" style="display:block; z-index: 99999; background-color: rgba(22,9,61, 0.5)">
            <div style="margin-top: 320px">
                <!--class= modal-dialog-->
                <div>
                    <div class="card h-100 ml-auto mr-auto w-50 bg-dark-blue text-white pl-2 pt-2 pr-2" style="border-bottom: none;">
                        <div class="container">
                            <div class="title text-white">
                                Create Coupons
                            </div>
                            <div>
                                <label class="text-white">Amount of coupons to generate</label>
                                <input type="number" placeholder="Enter coupon count" v-model.number="couponCount" />
                            </div>
                            <div>
                                <label class="text-white">Discount percentage</label>
                                <input type="number" placeholder="Enter discount percentage" v-model.number="couponDiscountPercentage" />
                            </div>
                            <div class="d-flex justify-content-end mt-5 mb-3">
                                <button class="btn btn-danger" v-on:click="showAddCoupons = false">Cancel</button>
                                <button class="btn btn-add-alt-2 border-white text-white ml-2" v-on:click="generateCoupon">Generate Coupons</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal-wrapper">
            <div class="card border-0" id="delete-modal">
                <div class="card-header bg-dark-blue text-white">
                    Confirm delete
                </div>
                <div class="card-body">
                    <div class="row mt-4">
                        <div class="col-12 text-center">
                            <h4>Are you sure you want to delete this {{deleteModalType}}</h4>
                        </div>
                    </div>
                    <div class="row mt-5">
                        <div class="col-12 d-flex justify-content-center">
                            <button class="btn btn-confirm-delete" v-on:click="deleteSelected">Confirm</button>
                            <button class="btn btn-danger ml-2" v-on:click="resetDelete">Cancel</button>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>
<script>

    import MixinsCertificates from '../../mixinsCertificates';
    import MixinsFileUploads from '../../mixinsFileUploads';

    //quill options
    var options = {
        placeholder: 'Write text here',
        readOnly: false,
        theme: 'snow'
    };

    export default {
        name: 'AdminCourseDetails',
        mixins: [MixinsCertificates, MixinsFileUploads],
        computed: {
            courseId() {
                // We will see what `params` is shortly
                return this.$route.params.id;
            },
            userRole() {
                var roles = this.$store.state.user.roles;
                return roles[0];
            },
            userId() {
                var user = this.$store.getters.getUser;
                return user.id;
            },
            user() {
                return this.$store.getters.getUser;
            },
            async currentSite() {
                var siteId = this.$store.state.user.siteId;
                await this.web("/sites/" + siteId, "Loading site").then((result) => {
                    this.sites = [result];
                })
            }
        },
        data: function () {
            return {
                selectedPage: 0,
                course: null,
                courseDetails: null,
                selectedTab: 0,
                selectedChapter: 0,
                authors: null,
                courses: [],
                sites: null,
                deleteConfirmation: false,
                showAddCoupons: false,
                allocations: null,
                courseAttendees: [],
                couponCount: 0,
                couponDiscountPercentage: 0,
                mode: "",
                editEnabled: null,
                draggingItem: null,
                preview: false,
                mQuills: [],
                hasCertificate: false,
                focusFirst: false,
                deleteModalType: null,
                deleteTarget: null,
                activeCourseFeature: null,

            }
        },
        watch: {

        },
        updated() {
        },
        async mounted() {
            $(".modal-wrapper").hide();
            this.sites = await this.web('/sites', "Loading sites");;
            var title = document.title;
            this.authors = await this.web(`/users?roles=author&siteTitle=${title}`, "Loading authors");

            //load course and course details
            if (this.courseId == 0) {

                this.course = {
                    id: 0,
                    name: "",
                    descriptionShort: "",
                    descriptionLong: "",
                    price: 0,
                    priceUsd: 0,
                    authorId: this.userId,
                    category: "",
                    enabled: true,
                    isFacilitated: false,
                    promoted: false,
                    siteId: this.user.siteId
                };
                this.editEnabled = true;

                this.courseDetails = {
                    name,
                    chapters: [],
                    certificateProperties: [],
                    courseFeatures: [],
                };

                this.courses = await this.web('/courses?filters=all', "Loading certificate configuration");
            }
            else {
                //load courses
                var response = await this.web("/courses/admin/" + this.courseId, "Loading courses");
                this.course = response.course;
                this.course.isFacilitated = !!this.course.isFacilitated;
                var site = await this.web("/sites/" + this.course.siteId, "Loading sites");
                this.course.site = site;
                this.courseDetails = response.details;
                if (!this.courseDetails.courseFeatures) {
                    this.courseDetails.courseFeatures = [];
                }

                //certificate properties might not be configured correctly after an import from edx
                if (!this.courseDetails.certificateProperties) {
                    this.courseDetails.certificateProperties = [];
                }

                //this.course.courseCoupons = []; //empty for now, might re-add this later
                this.course.courseCoupons = await this.web(`/coupons?courseId=${this.course.id}&filters=none`, "Loading coupons");

                this.courses = await this.web('/courses?filters=all', "Loading certificate configuration");

                this.allocations = await this.web("/courses/allocations/" + this.course.id, "Loading allocations");
                if (this.course.isFacilitated) {
                    await this.loadCourseAttendees();
                }
                this.editEnabled = false;
            }

            var crumbs = {};
            crumbs["/admin/courses"] = "Courses";
            crumbs["/admin/courses/" + this.courseId] = (this.courseId == 0 ? "Create courses" : this.course.name);
            this.$store.commit("breadCrumbs", crumbs);

        },
        methods: {
            removeFeature(feature) {
                var features = this.courseDetails.courseFeatures;
                this.courseDetails.courseFeatures = features.filter(f => {
                    if (f !== feature) {
                        return true;
                    }
                    return false;
                });
            },
            selectFeature(feature) {
                var features = this.courseDetails.courseFeatures;
                if (features.length === 0 || (features[features.length - 1].featureName !== "" && features[features.length - 1].featureValue !== "")) {
                    this.activeCourseFeature = feature;
                }
                else {
                    window.alert("Please fill in a name and value for the feature before continuing");
                }
            },
            addFeature() {
                var features = this.courseDetails.courseFeatures;

                var feature = {
                    featureIcon: "",
                    featureName: "",
                    featureValue: "",
                }

                if (features.length === 0 || (features[features.length - 1].featureName !== "" && features[features.length - 1].featureValue !== "")) {
                    this.courseDetails.courseFeatures.push(feature);
                    this.activeCourseFeature = feature;
                }
                else {
                    window.alert("Please fill in a name and value for the feature before adding a new one");
                }
            },
            resetDelete() {
                this.deleteModalType = null;
                this.deleteTarget = null;
                $(".modal-wrapper").hide(500);
            },
            deleteSelected() {
                var target = this.deleteTarget;
                var type = this.deleteModalType;

                switch (type) {
                    case "Certificate Property":
                        this.deleteItem(target.parent, target.target)
                        break;
                    case "chapter":
                        this.deleteItem(target.courseDetails, target.chapter);
                        break;
                    case "page":
                        this.deleteItem(target.chapter, target.page);
                        break;
                    default:
                        console.log("Unhandled delete type");
                        break;
                }
                this.resetDelete();
            },
            showDeleteModal(type, target) {
                //implement
                this.deleteModalType = type;
                this.deleteTarget = target;
                $(".modal-wrapper").show(500);
            },
            nameChanged(name) {
                this.course.name = name;
            },
            toggleShowAddCoupons() {
                this.showAddCoupons = true;
            },
            handleToggleEdit() {
                this.editEnabled = !this.editEnabled;
            },
            async handleTabClicked(tab, page, chapter) {
                this.selectedTab = tab;
                if (tab == 6) {
                    await this.loadCourseAttendees();
                }
                if (page) {
                    this.selectedPage = page;
                }
                if (chapter) {
                    this.selectedChapter = chapter;
                }
            },
            async loadCourseAttendees() {
                if (!this.course || !this.course.id || !this.course.isFacilitated) {
                    this.courseAttendees = [];
                    return;
                }

                this.courseAttendees = await this.web("/courses/attendees/" + this.course.id + "?includeDeleted=true", "Loading attendees");
            },

            handlePageChange(id) {
                this.selectedPage = id;
            },

            updateComponentHtml(value, id) {
                var currentChapter = this.courseDetails.chapters[this.selectedChapter];
                var pageComponents = currentChapter.pages[this.selectedPage].components;
                var component = pageComponents.filter(x => x.id === id)[0];
                if (component) {
                    component.html = value;
                }
            },
            addPage: function (chapter) {

                var vm = this.validateInputs();
                if (vm.validated) {
                    var page = {
                        id: this.$uuid.v4(),
                        name: "",
                        minimumPercentagePassMark: 0,
                        percentageWeight: 0,
                        randomSelection: 0,
                        components: []
                    };

                    chapter.pages.push(page);

                    var pageIndex = chapter.pages.indexOf(page);
                    var chapterIndex = this.courseDetails.chapters.indexOf(chapter);
                    this.selectedPage = pageIndex;
                    this.$nextTick(() => {
                        $(`#ch-${chapterIndex}p-${pageIndex}`).prop("readonly", false);
                        $(`#ch-${chapterIndex}p-${pageIndex}`).focus();
                    });
                }
            },

            addChapter: function () {
                var vm = this.validateInputs();
                if (vm.validated) {
                    var chapter = {
                        name: "",
                        pages: []
                    };
                    this.courseDetails.chapters.push(chapter);
                    var index = this.courseDetails.chapters.indexOf(chapter);

                    this.selectedPage = 0;
                    this.selectedTab = 4;
                    this.selectedChapter = index;
                    this.$nextTick(() => {
                        $(`#ch-${index}`).prop("readonly", false);
                        $(`#ch-${index}`).focus();
                    })
                }
            },
            getNextEmpty() {
                var titleInput = $("#course-name-input");
                var val = $(titleInput).val();
                if (!val || val == "") {
                    return titleInput;
                }
                //returns the next empty chapter or page input
                var types = ["chapter", "page"];
                for (var i = 0; i < types.length; i++) {

                    var inputs = $(`.${types[i]}-input`);

                    for (var j = 0; j < inputs.length; j++) {
                        var currentInput = inputs[j];
                        var value = $(currentInput).val();

                        if (!value || value == "") {
                            return currentInput;
                        }
                    }
                }

                return null;
            },
            validateInputs() {
                //if not null focus on
                var emptyInput = this.getNextEmpty();

                if (emptyInput) {
                    //set tab and page
                    if ($(emptyInput).prop("id") !== "course-name-input") {
                        var splitId = $(emptyInput).prop("id").split("p-");
                        var chapterIndex = splitId[0].split("ch-")[1];
                        var pageIndex = splitId[1];

                        this.selectedChapter = chapterIndex;
                        this.selectedPage = pageIndex;
                    }
                    $(emptyInput).prop("readonly", false);
                    $(emptyInput).focus();

                    return {
                        validated: false,
                    };
                }
                else {
                    return {
                        validated: true,
                    }
                }
            },
            initializeQuills() {
                var quills = $(".rich-text");
                for (var i = 0; i < quills.length; i++) {

                    var quill = new Quill(quills[i], options);
                    var val = $(quill.container).siblings(".text-value").val();

                    if (val != null && val != "") {
                        quill.setContents(JSON.parse(val));
                    }

                    if (this.mQuills.indexOf(quill) < 0) {
                        this.mQuills.push(quill);
                    }
                }
            },
            storeQuills() {
                for (var i = 0; i < mQuills.length; i++) {
                    var input = $(mQuills[i].container).siblings(".question-value");
                    var content = mQuills[i].getContents();
                    content = JSON.stringify(content);

                    if (content != null && content != "{\"ops\":[{\"insert\":\"\\n\"}]}") {
                        $(input).val(content);
                    }
                }
            },

            inputEnter(event, chapterId, pageId) {
                if (pageId === null) {
                    if (this.selectedChapter !== chapterId) {
                        this.selectedChapter = chapterId;
                    }
                }
                else {
                    if (this.selectedChapter !== chapterId) {
                        this.selectedChapter = chapterId;
                    }
                    if (this.selectedPage !== pageId) {
                        this.selectedPage = pageId;
                    }
                }

                $(event.target).siblings("input").prop("readonly", false);
                $(event.target).siblings("input").focus();
            },

            inputLeave(event) {
                $(event.target).prop("readonly", true);
            },

            toggleShow(event, idx, hidden) {
                if (event.target) {
                    var target = event.target;
                }
                else {
                    var target = event;
                }
                this.selectedTab = 4; this.selectedPage = 0; this.selectedChapter = idx;
                var chapterList = $(target).parents(".item-title");
                var pageList = $(chapterList).children(".pages");
                var listHidden = $(pageList[0]).prop("hidden");

                if (hidden !== undefined) {
                    listHidden = hidden;
                }

                if (listHidden === true) {
                    $(".pages").prop("hidden", true);
                    $(pageList[0]).prop("hidden", false);
                    $(chapterList[0]).prop("draggable", false);
                }
                else {
                    $(pageList[0]).prop("hidden", true);
                    $(chapterList[0]).prop("draggable", true);
                }

            },

            handleFileChange(event, reference, key) {

                //get files
                var validFiles = false;
                var files;
                if (event.files) {
                    files = event.files;
                }
                else if ($(event.target)[0] && $(event.target)[0].files) {
                    files = $(event.target)[0].files;
                }
                else {
                    console.error("Input has no files");
                    return;
                }

                //validate file sizes
                if (files.length > 0) {
                    for (var i = 0; i < files.length; i++) {
                        var file = files[i];
                        if (file.type === "image/jpeg") {
                            var fileSizeMb = file.size / 1024 / 1024;
                            if (fileSizeMb > 2) {
                                alert("Image file size is greater than 2mb please use a smaller image");
                            }
                            else {
                                if (fileSizeMb > 1 && fileSizeMb <= 2) {
                                    alert("Image file size is greater than 1mb this may affect site performance consider resizing the image or choosing another one.")
                                }
                                validFiles = true;
                            }
                        }
                        else {
                            //allow other file types
                            validFiles = true;
                        }
                    }
                }
                if (validFiles) {
                    this.onFileChange(event, reference, key);
                }
            },

            startDrag(evt, item) {
                if (this.editEnabled) {
                    if (this.draggingItem == null) {
                        var item = evt.srcElement;
                        this.draggingItem = item;
                    }

                    evt.dataTransfer.dropEffect = 'move'
                    evt.dataTransfer.effectAllowed = 'move'
                    evt.dataTransfer.setData('itemID', item.id)
                }
            },
            onDrop(evt, target) {
                if (this.editEnabled) {

                    evt.preventDefault();
                    var srcElem = evt.srcElement;
                    if (this.draggingItem !== null) {
                        //check if draggingItem is chapter

                        this.itemMove(this.draggingItem, srcElem);
                    }
                }
            },
            itemMove(item, target) {
                console.log("test:itemMove", item, target);
                var itemInputs = $(item).find("input");
                var parentTarget = $(target).closest(".curriculum");
                var targetInputs = $(parentTarget).find("input");

                if (this.editEnabled && itemInputs.length && targetInputs.length) {

                    var itemSplit = $(itemInputs[0]).prop("id").split("p-");
                    var itemChapterIndex = itemSplit[0].replace("ch-", "");
                    var itemPageIndex = itemSplit[1];

                    var targetSplit = $(targetInputs[0]).prop("id").split("p-");
                    var targetChapterIndex = targetSplit[0].replace("ch-", "");
                    var targetPageIndex = targetSplit[1];

                    //logic for moving
                    if (itemPageIndex !== undefined && targetPageIndex !== undefined) {

                        let sourcePage = this.courseDetails.chapters[itemChapterIndex].pages[itemPageIndex];
                        let targetPage = this.courseDetails.chapters[targetChapterIndex].pages[targetPageIndex];

                        let idx = this.courseDetails.chapters[itemChapterIndex].pages.indexOf(sourcePage);
                        this.courseDetails.chapters[itemChapterIndex].pages.splice(idx, 1);

                        idx = this.courseDetails.chapters[targetChapterIndex].pages.indexOf(targetPage);
                        this.courseDetails.chapters[targetChapterIndex].pages.splice(idx, 0, sourcePage);
                        this.selectedPage = idx;

                    }
                    else if (itemChapterIndex !== undefined && targetChapterIndex !== undefined) {
                        let targetHolder = this.courseDetails.chapters[targetChapterIndex];
                        this.courseDetails.chapters.splice(targetChapterIndex, 1, this.courseDetails.chapters[itemChapterIndex]);
                        this.courseDetails.chapters.splice(itemChapterIndex, 1, targetHolder);
                        this.selectedChapter = targetChapterIndex;
                        //hide all page lists
                        //show chapter page list
                        var list = $(item).parent(".curriculum").children(".pages")[0];
                        var itemShown = $(list).is(":visible");
                        this.toggleShow(target, targetChapterIndex, itemShown);
                    }
                    //check for components
                    else {
                        var wrapper = $(item).closest(".cms-course-wrapper-1");
                        var components = $(wrapper).find(".cms-course-wrapper-2").toArray();
                        var targetContainer = $(target).closest(".cms-course-wrapper-2")[0];

                        var itemIndex = components.indexOf(item);
                        var targetIndex = components.indexOf(targetContainer);

                        let targetHolder = this.courseDetails.chapters[this.selectedChapter].pages[this.selectedPage].components[targetIndex];
                        this.courseDetails.chapters[this.selectedChapter].pages[this.selectedPage].components.splice(targetIndex, 1, this.courseDetails.chapters[this.selectedChapter].pages[this.selectedPage].components[itemIndex]);
                        this.courseDetails.chapters[this.selectedChapter].pages[this.selectedPage].components.splice(itemIndex, 1, targetHolder);

                    }

                    this.draggingItem = null;
                }
            },
            toggleEditPreview() {

                this.editEnabled = !this.editEnabled;
                this.initializeQuills();
            },

            onTypeChange: function (component) {
                component.file = null;
                component.name = null;
                component.fileName = null;
                component.html = null;
            },
            courseHasQuestions() {
                for (var i = 0; i < this.courseDetails.chapters.length; i++) {
                    var currentChapter = this.courseDetails.chapters[i];

                    for (var j = 0; j < currentChapter.pages.length; j++) {
                        var currentPage = currentChapter.pages[j];

                        for (var k = 0; k < currentPage.components.length; k++) {
                            var currentComponent = currentPage.components[k];
                            if (currentComponent.type === "question" || currentComponent.type === "scorm") {
                                return true;
                            }
                        }
                    }
                }
                return false;
            },
            hasQuestions(event, page) {
                var hasQuestOrScorm = false;
                for (var i = 0; i < page.components.length; i++) {
                    var comp = page.components[i];

                    if (comp.type === "question" || comp.type === "scorm") {
                        hasQuestOrScorm = true;
                        break;
                    }
                }
                return hasQuestOrScorm;
            },

            async save() {
                debugger;
                $('input').removeClass("bdRed");
                $('select').removeClass("bdRed");

                //validate pass marks not empty if course has questions
                if (this.courseHasQuestions() && (this.courseDetails.minimumPercentagePassMark == null || this.courseDetails.minimumPercentagePassMark == undefined)) {

                    var coursePassmark = $("#course-passmark");
                    this.editEnabled = true;
                    this.selectedTab = 0;
                    this.$nextTick(() => {
                        $(coursePassmark).focus();
                    });
                    $(coursePassmark).addClass('bdRed');

                    return;
                }

                //focus on next empty passmark
                var pagePassmarks = $(".page-passmark");
                var pageWeights = $(".page-weight");
                if (pagePassmarks.length == pageWeights.length) {
                    for (var i = 0; i < pagePassmarks.length; i++) {
                        var currentPassmark = pagePassmarks[i];
                        var currentWeight = pageWeights[i];

                        if ($(currentPassmark).val() == '') {
                            this.editEnabled = true;

                            var split = $(currentPassmark).attr("id").split("p-");
                            var pageId = split[1];
                            var chapterId = split[0].split("ch-")[1];
                            this.selectedTab = 4;
                            this.selectedPage = pageId;
                            this.selectedChapter = chapterId;
                            this.$nextTick(() => {
                                $(currentPassmark).focus();
                            });
                            $(currentPassmark).addClass('bdRed');
                            return;
                        }

                        if ($(currentWeight).val() == '') {
                            this.editEnabled = true;

                            var split = currentWeight.attr("id").split("p-");
                            var pageId = split[1];
                            var chapterId = split[0].split("ch-")[1];
                            this.selectedTab = 4;
                            this.selectedPage = pageId;
                            this.selectedChapter = chapterId;
                            this.$nextTick(() => {
                                $(currentWeight).focus();
                            });
                            $(currentWeight).addClass('bdRed');
                            return;
                        }
                    }
                }

                //validate course name and focus
                if (!this.course.name || this.course.name == "") {

                    this.$nextTick(() => {
                        $("#course-name-input").focus();
                    })
                    $("#course-name-input").addClass('bdRed');
                    return;
                }


                for (var c = 0; c < this.courseDetails.chapters.length; c++) {
                    var chapter = this.courseDetails.chapters[c];
                    for (var p = 0; p < chapter.pages.length; p++) {

                        //ensure all pages with questions have passmarks
                        var page = chapter.pages[p];
                        if ((page.minimumPercentagePassMark == null || page.minimumPercentagePassMark == undefined) && this.hasQuestions(null, page)) {
                            this.selectedTab = 4;
                            this.selectedPage = p;
                            this.selectedChapter = c;

                            const id = `#pm-ch-${c}p-${p}`;
                            var pmInput = $(id);
                            this.$nextTick(() => {
                                $(pmInput).focus();
                            })
                            $(pmInput).addClass("bdRed");

                            return;
                        }

                        //if (page.percentageWeight === 0 && this.hasQuestions(null, page)) {
                        //    this.selectedTab = 4;
                        //    this.selectedPage = p;
                        //    this.selectedChapter = c;
                        //    const id = `#pw-ch-${c}p-${p}`;
                        //    var pwInput = $(id);
                        //    this.$nextTick(() => {
                        //        $(pwInput).focus();
                        //    })
                        //    $(pwInput).addClass("bdRed");
                        //    return;
                        //}

                        //validate single scorm file per page and no mixing of scorm and question components
                        var scormComponentCount = 0;
                        var questionsCount = 0;
                        for (var co = 0; co < page.components.length; co++) {
                            var component = page.components[co];

                            if (component.type == "scorm")
                                scormComponentCount++;
                            if (component.type == "question")
                                questionsCount++;
                        }

                        if (scormComponentCount > 1) {
                            alert("A maximum of 1 SCORM per page is allowed");
                            return;
                        }
                        if (scormComponentCount > 0 && questionsCount > 0) {
                            alert("Scorm files and questions cannot be mixed in the same page");
                            return;
                        }
                    }
                }

                //validate course assigned to site
                if (!this.course.siteId || this.course.siteId == "none") {
                    //alert("Course must be assigned to a site");
                    this.selectedTab = 0;
                    var input = $("#admin-siteId");
                    $(input).addClass("bdRed");
                    this.$nextTick(() => {
                        $(input).focus();
                    })
                    return;
                }

                //upload course image
                if (this.course.imageFile) {
                    await this.uploadFilesAsync(this.course, "image");
                }

                //upload course content images
                for (var c = 0; c < this.courseDetails.chapters.length; c++) {
                    var chapter = this.courseDetails.chapters[c];
                    for (var p = 0; p < chapter.pages.length; p++) {

                        var page = chapter.pages[p];
                        for (var co = 0; co < page.components.length; co++) {
                            var component = page.components[co];

                            await this.uploadFilesAsync(component, '');
                        }
                    }
                }

                //upload certificate images
                if (this.courseDetails.certificateProperties) {
                    for (var c = 0; c < this.courseDetails.certificateProperties.length; c++) {
                        var property = this.courseDetails.certificateProperties[c]
                        if (property.file) {
                            await this.uploadFilesAsync(property, '');
                        }
                        if (property.imageFile) {
                            await this.uploadFilesAsync(property, 'image');
                        }
                    }
                }

                //Upload course content
                if (this.course.price == "")
                    this.course.price = null;

                if (this.course.priceUsd == "")
                    this.course.priceUsd = null;

                if (this.course.authorId == "")
                    this.course.authorId = null;

                const response = await this.web('/courses', `Uploading course data`, {
                    course: this.course,
                    details: this.courseDetails
                });

                if (this.courseId == 0) {
                    this.$router.replace("/admin/courses/" + response.course.id);
                    this.$router.go();
                }
                else {
                    this.course = response.course;
                    this.courseDetails = response.details;
                    this.course.isFacilitated = !!this.course.isFacilitated;
                    if (this.course.isFacilitated) {
                        await this.loadCourseAttendees();
                    }
                    else {
                        this.courseAttendees = [];
                        if (this.selectedTab == 6) {
                            this.selectedTab = 0;
                        }
                    }
                }
            },
            async clone() {

                await this.save();
                const response = await this.web('/courses/clone/' + this.course.id, `Cloning course data`);
                this.$router.replace("/admin/courses/" + response.data.course.id);
                this.$router.go();

            },
            addAnswer: function (component) {
                component.answers.unshift({
                    answerText: "",
                    isCorrect: false
                });
            },
            addComponent: function (page) {
                page.components.unshift({
                    id: this.$uuid.v4(),
                    type: "html",
                    file: null,
                    name: "",
                    html: "",
                    questionText: "",
                    solutionText: "",
                    fileName: "",
                    answers: []
                });
            },
            clearWarning(event) {
                $(event.target).removeClass('bdRed');
            },

            deleteItem: function (parent, item) {
                for (var prop in parent) {
                    if (Array.isArray(parent[prop])) {
                        var i = parent[prop].indexOf(item);
                        if (i > -1) {
                            parent[prop].splice(i, 1);
                            break;
                        }
                    }
                }
            },
            moveItem: function (parent, item, moveUp) {
                console.log("test:moveItem");
                debugger;
                for (var prop in parent) {
                    if (Array.isArray(parent[prop])) {
                        var i = parent[prop].indexOf(item);
                        if (i > -1) {
                            if (moveUp && i != 0) {
                                parent[prop].splice(i, 1);
                                parent[prop].splice(i - 1, 0, item);
                            }
                            else if (!moveUp && i < parent[prop].length - 1) {
                                parent[prop].splice(i, 1);
                                parent[prop].splice(i + 1, 0, item);
                            }
                            break;
                        }
                    }
                }
            },

            async loadFromFile(chapter) {
                var fileElement = $("<input type='file'/>");
                var t = this;
                $(fileElement).on("change", function (evt) {

                    var f = evt.target.files[0];
                    const reader = new FileReader();
                    // Wait till complete
                    reader.onload = function (event) {
                        // The file's text will be printed here

                        var text = reader.result;
                        text = text.replace(/\t/g, "");
                        text = text.replace(/\r\n/g, "\n");
                        while (text.indexOf("  ") > -1) {
                            text = text.replace(/  /g, " ");
                        }

                        var lines = text.split("\n");

                        var page = {
                            id: t.$uuid.v4(),
                            name: f.name,
                            minimumPercentagePassMark: 0,
                            percentageWeight: 0,
                            randomSelection: 0,
                            components: []
                        };
                        chapter.pages.push(page);

                        var question = null;
                        for (var i = 0; i < lines.length; i++) {
                            var line = lines[i].trim();
                            if (line.length > 0) {
                                if (line.indexOf("===") == 0) { //solution
                                    line = line.substring(3).trim();
                                    question.solutionText = line;
                                }
                                else if (line.indexOf("==") == 0) { //question

                                    line = line.substring(2).trim();

                                    //new question
                                    question = {
                                        id: t.$uuid.v4(),
                                        type: "question",
                                        file: null,
                                        name: "",
                                        html: "",
                                        questionText: line,
                                        fileName: "",
                                        answers: []
                                    };

                                    page.components.push(question);
                                }
                                else if (line.indexOf("=") == 0) { //title
                                    line = line.substring(1).trim();
                                    question = null;
                                    page.components.push({
                                        id: t.$uuid.v4(),
                                        type: "html",
                                        file: null,
                                        name: "",
                                        html: line,
                                        questionText: "",
                                        fileName: "",
                                        answers: []
                                    });

                                } else {
                                    //this must be an answer?
                                    if (!question) {
                                        throw "Invalid format"
                                    }

                                    var isCorrectAnswer = false;
                                    if (line.toUpperCase().indexOf("[X]") > -1) {
                                        line = line.replace("[X]", "").replace("[x]").trim();
                                        isCorrectAnswer = true;
                                    }

                                    question.answers.push({
                                        answerText: line,
                                        isCorrect: isCorrectAnswer
                                    });
                                }
                            }
                        }
                    }
                    // Make sure to handle error states
                    reader.onerror = function (e) {
                        reject(e);
                    };

                    reader.readAsText(f);

                });
                fileElement.click();

            },
            async deleteCourse() {

                this.deleteConfirmation = false;
                await this.web("/courses/delete/" + this.course.id, "Deleting course");
                this.$router.replace("/admin/courses/");

            },
            async evaluate() {

                this.allocations = await this.web("/courses/allocations", "Updating allocations", {
                    allocations: this.allocations,
                    courseId: this.course.id,
                    reEvaluate: true
                });
            },
            async generateCoupon() {
                this.course.courseCoupons = await this.web("/coupons", "Generating new coupons", {
                    courseIds: [this.course.id],
                    count: this.couponCount,
                    discountPercentage: this.couponDiscountPercentage,
                    siteId: this.course.siteId,
                });
                this.showAddCoupons = false;
            }
        },

    }

</script>




<style>

    .tab-content {
        padding: 40px;
    }

    .modal-wrapper {
        position: fixed;
        z-index: 10000;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        height: 100%;
        width: 100%;
        background-color: rgba(0,0,0,0.5);
    }

    #delete-modal {
        top: 200px;
        position: relative;
        width: 600px;
        height: 300px;
        left: 36%;
    }

    .btn-confirm-delete {
        background-color: #42C1C4;
        color: white;
    }

        .btn-confirm-delete:hover {
            background-color: white;
            color: #42C1C4;
        }

    .bdRed {
        border: 1px solid red !important;
    }

    .switch-wrapper {
        min-width: 60px;
    }

    /* The switch - the box around the slider */
    .switch {
        position: relative;
        display: inline-block;
        width: 60px;
        height: 34px;
    }

        /* Hide default HTML checkbox */
        .switch input {
            opacity: 0;
            width: 0;
            height: 0;
        }

    /* The slider */
    .slider {
        position: absolute;
        cursor: pointer;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: #ccc;
        -webkit-transition: .4s;
        transition: .4s;
    }

        .slider:before {
            position: absolute;
            content: "";
            height: 26px;
            width: 26px;
            left: 4px;
            bottom: 4px;
            background-color: white;
            -webkit-transition: .4s;
            transition: .4s;
        }

    input:checked + .slider {
        background-color: #42C1C4;
    }

    input:focus + .slider {
        box-shadow: 0 0 1px #42C1C4;
    }

    input:checked + .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
    }

    /* Rounded sliders */
    .slider.round {
        border-radius: 34px;
    }

        .slider.round:before {
            border-radius: 50%;
        }


    .tab-content {
        background-color: #f1f1f1 !important;
    }

    label {
        text-transform: uppercase;
        font-weight: 700;
        color: #282D69;
    }


    .activePage {
        border: 1px dashed white;
    }

        .activePage i:hover {
            color: #42c1c4;
        }





    .content-wrapper {
        border-top: 1px solid #282d69;
        padding: 5px 10px;
    }

    .top-wrapper {
        padding: 10px;
        padding-bottom: 0;
    }

    .tab-content {
        padding-bottom: 0 !important;
    }

    .tab-content-wrap {
        background-color: white;
    }

    .options-btn {
        width: 40px;
        height: 40px;
        padding: 5px;
    }

        .options-btn:hover {
            cursor: pointer;
        }

    .course-image {
        max-width: 370px;
        min-height: 100px;
        max-height: 270px;
    }

    li input {
        border: none !important;
    }

    li .active .inner {
        border-bottom: 2px solid #42C1C4 !important;
    }

    .active .inner-module {
        border-bottom: 2px solid #282D69 !important;
    }

    .item-title input:hover {
        cursor: pointer;
        background-color: #42c1c4 !important;
        color: white !important;
    }

    .item-title input:read-write:focus {
        background-color: #42c1c4 !important;
        border: 1px solid #282D69;
        color: white !important;
    }

    .item-title span:hover {
        color: #42c1c4 !important;
        cursor: pointer;
    }

    .list-wrapper {
        background-color: #282D69;
        color: white;
        padding-left: 15px !important;
    }

    .fa-pencil {
        margin-left: 15px;
    }

    .pages {
        background-color: #282D69;
        color: white;
        padding-bottom: 1px;
    }

    .page-input {
        height: 30px !important;
        line-height: 19px;
        font-size: 17px;
        background-color: transparent !important;
        color: white !important;
    }

    .chapter-input {
        height: 30px !important;
        line-height: 20px;
        font-size: 17px;
        padding: 0 5px !important;
        background-color: transparent !important;
        color: white !important;
    }

    .active .chapter-input {
        border: 1px solid white;
    }

    .btn-add {
        border-radius: 8px 8px 0 0;
        background-color: #42C1C4 !important;
        right: 0;
        border: 1px solid white;
        border-bottom: none;
    }

        .btn-add:hover {
            background-color: white !important;
            color: #282D69 !important;
            border: 1px solid #282d69;
            border-bottom: none;
        }

    .btn-add-page {
        border-radius: 8px 8px 0 0;
        background-color: #282d69;
        color: white;
        right: 0;
        border: 1px solid white;
        border-bottom: none;
    }

        .btn-add-page:hover {
            background-color: white !important;
            color: #282d69 !important;
            border-bottom: none !important;
        }

    .btn-add-alt {
        border-radius: 8px 8px 0 0;
        background-color: #282d69;
        color: white;
        right: 0;
        border: 1px solid #282d69;
        border-bottom: none;
    }

        .btn-add-alt:hover {
            background-color: white !important;
            color: #282d69 !important;
            border: 1px solid #282d69 !important;
            border-bottom: none !important;
        }

    .btn-delete {
        background-color: #f12525;
        color: white;
        border: 1px solid white;
        border-bottom: none !important;
        border-radius: 8px 8px 0 0;
        right: 0;
    }

        .btn-delete:hover {
            border: 1px solid red;
            border-bottom: none !important;
            background-color: white;
            color: red;
        }

    .btn-delete-alt {
        background-color: #f12525;
        color: white;
        border: 1px solid white;
        border-right: none !important;
        border-radius: 8px 0 0 8px;
        margin-right: -6px;
        right: 0;
    }

        .btn-delete-alt:hover {
            border: 1px solid red;
            border-right: none !important;
            background-color: white;
            color: red;
        }

    .btn-select {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        padding: 5px;
    }

    .flex {
        display: flex;
    }

    .back-button {
        z-index: 1000;
        background-color: transparent !important;
        border: none;
        width: fit-content;
        justify-content: end !important;
        flex-direction: row !important;
        padding-right: 35px;
    }

    .btn-save {
        height: 50px;
        width: 100px;
        border-radius: 12px;
    }

    .btn-clone {
        height: 50px;
        width: 100px;
        border-radius: 12px;
    }

    .btn-delete {
        height: 50px;
        width: 180px;
        border-radius: 12px;
        background-color: rgb(256,50,50);
        border-bottom: 1px solid red !important;
    }

        .btn-delete:hover {
            border-bottom: 1px solid red !important;
        }
</style>
